import LocalizedStrings from 'react-localization';

// Messages JSON files
import skMessages from './sk/index';
import enMessages from './en/index';
import deMessages from './de/index';
import zhMessages from './cn/index';

export const strings = new LocalizedStrings({
    sk: skMessages,
    en: enMessages,
    de: deMessages,
    zh: zhMessages
});
